import styled from 'styled-components';

export const FooterContentWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
`;

export const FooterName = styled.span`
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FooterStatusWrap = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;
